import React, { useEffect, useMemo, useState } from "react";
import { MdOutlineFileUpload } from "react-icons/md";
import {
  AiOutlineEye,
  AiOutlineDownload,
  AiOutlineDelete,
} from "react-icons/ai";
import { Upload, Select, Spin, message, Dropdown } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import ImgCrop from "antd-img-crop";
import Instance from "../../AxiosConfig";
import { PhoneInput } from "react-international-phone";
import countryList from "react-select-country-list";
import { useNavigate, useParams } from "react-router-dom";

const EditTaxInvoice = () => {
  const [agentData, setAgentData] = useState([]);
  const [standards, setStandards] = useState([]);
  const [existingTaxInvoices, setExistingTaxInvoices] = useState([]);
  const [selectedBank, setSelectedBank] = useState(null);
  const [taxInvoiceNo, setTaxInvoiceNo] = useState("");
  const [taxInvoiceError, setTaxInvoiceError] = useState("");
  const [currency, setCurrency] = useState("INR");
  const [isSplitTax, setIsSplitTax] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [selectedStandard, setSelectedStandard] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [alternateEmailInput, setAlternateEmailInput] = useState("");
  const [alternateEmails, setAlternateEmails] = useState([]);
  const [city, setCity] = useState("");
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [gstNumber, setGstNumber] = useState("");
  const [website, setWebsite] = useState("");
  const [totalClosure, setTotalClosure] = useState("");
  const [moneyReceived, setMoneyReceived] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [logoFile, setLogoFile] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [taxVoiceData, setTaxvoiceData] = useState([]);
  const [sacCode, setSacCode] = useState("99831");
  const [agentName, setAgentName] = useState("");
  const [certificationType, setCertificationType] = useState("");
  const [clientName, setClientName] = useState("");
  const countryOptions = useMemo(() => countryList().getData(), []);
  const FIXED_GST_PERCENT = 18;
  const { id } = useParams();
  const [invoiceData, setInvoiceData] = useState(null);
  const [invoiceDate, setInvoiceDate] = useState("");
  const [pendingAmount, setPendingAmount] = useState(0);
  const [relatedInvoices, setRelatedInvoices] = useState([]);
  const toDateInputValue = (isoString) => {
    if (!isoString) return "";
    return isoString.split("T")[0];
  };
  const [usdExchangeRate, setUsdExchangeRate] = useState("");
  const [totalBaseValueInr, setTotalBaseValueInr] = useState("");
  const [errors, setErrors] = useState({});
  const [companyId, setCompanyId] = useState(null);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [searchText, setSearchText] = useState("");

  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  useEffect(() => {
    const fetchAll = async () => {
      try {
        const [agentsRes, standardsRes, invoicesRes] = await Promise.all([
          Instance.get("/agents/dropdown"),
          Instance.get("/standards"),
          Instance.get("/invoices"),
        ]);
        // console.log("standardsRes.data.standards:", standardsRes?.data?.standards);

        if (agentsRes?.data?.agents) setAgentData(agentsRes.data.agents);
        console.log("agentData", agentsRes);
        if (standardsRes?.data.standards)
          setStandards(standardsRes.data.standards);
        if (invoicesRes?.data) {
          const list = invoicesRes.data.invoices
            .map((i) => (i.invoiceNo || "").toString().toUpperCase())
            .filter(Boolean);
          setExistingTaxInvoices(list);
        }
      } catch (err) {
        console.error(
          "Lookup fetch error:",
          err?.response?.data || err.message,
        );
        message.error("Failed to load lookup data. Check console.");
      }
    };
    fetchAll();
  }, []);

  useEffect(() => {
    const fetchInvoice = async () => {
      if (!id) {
        message.error("No invoice ID found");
        navigate("/tax-invoice");
        return;
      }

      try {
        setLoading(true);
        const token = localStorage.getItem("token");
        const response = await Instance.get(`/invoices/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log(response, "invoice");
        if (response.data.invoice) {
          setInvoiceData(response.data.invoice);
          setRelatedInvoices(response.data.relatedInvoices || []); // ADD THIS LINE
          fillInvoiceForm(response.data.invoice);
        }
      } catch (err) {
        console.error(err);
        message.error(err.response?.data?.message || "Invoice not found");
        navigate("/tax-invoice");
      } finally {
        setLoading(false);
      }
    };

    fetchInvoice();
  }, [id, navigate]);

  const fillInvoiceForm = (invoice = {}) => {
    setTaxInvoiceNo(invoice.invoiceNo || "");
    setCurrency(invoice.currency || "INR");
    setIsSplitTax(Boolean(invoice.isSplitTax));
    setSelectedAgent(invoice?.agentId?._id || null);
    setAgentName(invoice?.agentId?.agentName);
    setSelectedStandard(invoice.standard.map((s) => s._id));
    setCompanyName(invoice.companyName || "");
    setPhone(invoice.phone || "");
    setEmail(invoice.email || "");
    setAlternateEmails(invoice.alternateEmails || []);
    setCity(invoice.city || "");
    setAddress(invoice.address || "");
    setWebsite(invoice.website || "");
    setGstNumber(invoice.gstNumber || "");
    setSacCode(invoice.SacCode || "");
    setUsdExchangeRate(invoice?.exchangeRateForBaseClosure || "");
    setTotalBaseValueInr(invoice?.baseClosureAmountINR || "");
    setClientName(invoice.ClientName || "");
    setCertificationType(invoice.certificationType || "");
    setSelectedCountry(
      invoice.country
        ? { label: invoice.country, value: invoice.country }
        : null,
    );
    setPendingAmount(invoice.PendingPaymentInINR || 0);

    setInvoiceDate(toDateInputValue(invoice.InvoiceDate));
    setTotalClosure(
      typeof invoice.baseClosureAmount === "number"
        ? invoice.baseClosureAmount
        : "",
    );
    setMoneyReceived(
      typeof invoice.moneyReceived === "number" ? invoice.moneyReceived : "",
    );
    setPaymentTermsCount(invoice.paymentInstallments || 1);

    // Payment Terms mapping
    const mappedTerms = (invoice.terms || []).map((t) => ({
      _id: t._id,
      name: t.termName || "",
      amount: t.baseAmount || 0,
      gstAmount: t.gstAmount || 0,
      tds: t.TDSAmmount || 0,
      total: t.termTotal || 0,
      status: t.status || "Pending",
      exchangeRate: t.exchangeRate || "",
    }));
    setSelectedBank(invoice.selectedBank || null);

    setTerms(
      mappedTerms.length
        ? mappedTerms
        : [
          {
            name: "Term 1",
            amount: "",
            gstAmount: 0,
            tds: "",
            total: 0,
            status: "Pending",
          },
        ],
    );
    if (invoice.attachments && invoice.attachments.length > 0) {
      setUploadedFiles(
        invoice.attachments.map((att) => ({
          name: att.fileName || att.originalName || "Unknown file",
          size: "Cloudinary",
          date: new Date().toLocaleDateString(),
          url: att.fileUrl,
          isExisting: true,
        })),
      );
    } else {
      setUploadedFiles([]);
    }
  };

  useEffect(() => {
    const fetchCompanyData = async () => {
      setLoading(true);
      try {
        const response = await Instance.get("/company/names-and-ids");
        console.log("API Company Response:", response);

        if (response.status === 200 || response.status === 201) {
          setCompanyDetails(response?.data || []);
        }
      } catch (error) {
        console.error("Fetch error:", error);
        message.error("Failed to load company details");
      } finally {
        setLoading(false);
      }
    };

    fetchCompanyData();
  }, []);

  const handleCompanySelect = async (id) => {
    try {
      setLoading(true);

      const response = await Instance.get(`/company/${id}`);
      const selectedCompany = response?.data;

      if (!selectedCompany) return;

      console.log("Company Full Data:", response);

      setCompanyId(selectedCompany?.companyId);
      setCompanyName(selectedCompany.companyName);
      setClientName(selectedCompany.clientName || "");
      setEmail(selectedCompany.email || "");
      setPhone(selectedCompany.mobileNumber || "");
      setWebsite(selectedCompany.website || "");
      setAddress(selectedCompany.address || "");
      setCity(selectedCompany.city || "");
      setGstNumber(selectedCompany.gstNumber || "");

      setSelectedCountry(
        selectedCompany.country
          ? { label: selectedCompany.country, value: selectedCompany.country }
          : null,
      );
    } catch (error) {
      console.error("Error fetching company:", error);
      message.error("Failed to load company details");
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    const newErrors = {};

    if (!taxInvoiceNo.trim()) {
      newErrors.invoiceNo = "Invoice number is required";
    }

    if (!currency) {
      newErrors.currency = "Currency is required";
    }
    if (!selectedAgent) {
      newErrors.agent = "Agent is required";
    }

    if (!selectedStandard || selectedStandard.length === 0) {
      newErrors.standard = "At least one standard is required";
    }
    if (!companyName.trim()) {
      newErrors.companyName = "Company name is required";
    }

    if (!totalClosure || Number(totalClosure) <= 0) {
      newErrors.baseClosureAmount = "Total closure amount is required";
    }
    // ✅ Non-INR validations
    if (!isINR) {
      if (!usdExchangeRate || Number(usdExchangeRate) <= 0) {
        newErrors.exchangeRateForBaseClosure = "Exchange rate is required";
      }

      if (!totalBaseValueInr || Number(totalBaseValueInr) <= 0) {
        newErrors.baseClosureAmountINR = "Total base value in INR is required";
      }

      // ✅ Terms validation
      const termErrors = [];

      terms.forEach((term, index) => {
        const termError = {};

        if (!term.exchangeRate || Number(term.exchangeRate) <= 0) {
          termError.exchangeRate = "Required";
        }

        const totalInINR =
          (parseFloat(term.total || 0) || 0) *
          (parseFloat(term.exchangeRate || 0) || 0);

        if (!totalInINR || totalInINR <= 0) {
          termError.totalInINR = "Invalid INR value";
        }

        termErrors[index] = termError;
      });

      if (termErrors.some((e) => Object.keys(e).length > 0)) {
        newErrors.terms = termErrors;
      }
    }
    // ❌ STOP if errors
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      message.error("Please fill all required fields");
      return;
    }

    // ✅ clear errors if valid
    setErrors({});
    const payload = {
      invoiceNo: taxInvoiceNo.trim(),
      currency,
      agentId: selectedAgent || null,
      standard: selectedStandard || null,
      companyName: companyName.trim(),
      ClientName: clientName.trim(),
      phone: phone.trim(),
      email: email.trim(),
      alternateEmails,
      city: city.trim(),
      address: address.trim(),
      website: website.trim(),
      gstNumber: gstNumber.trim(),
      isSplitTax: isINR ? isSplitTax : false,
      SacCode: sacCode.trim(),
      certificationType: certificationType.trim(),
      country: selectedCountry?.value || "",
      baseClosureAmount: Number(totalClosure) || 0,
      moneyReceived: Number(moneyReceived) || 0,
      paymentInstallments: paymentTermsCount,
      TotalBaseAmount: totalBaseFromTerms,
      TotalGSTAmount: totalGstFromTerms,
      TotalTDSAmount: totalTdsFromTerms,
      GrandTotalBaseAmmount: grandTotalFromTerms,
      PendingPaymentInINR: pendingAmount,
      InvoiceDate: invoiceDate || null,
      baseClosureAmountINR: Number(totalBaseValueInr) || 0,
      exchangeRateForBaseClosure: Number(usdExchangeRate) || 0,
      companyDetails: selectedCompany?._id, // company id
      selectedBankId: selectedBank?._id,
      terms: terms.map((t, index) => {
        const base = Number(t.amount) || 0;
        const gst = Number(t.gstAmount) || 0;
        const total = Number(t.total) || 0;
        const exchangeRate = !isINR ? Number(t.exchangeRate) || 0 : 1;

        return {
          _id: t._id,
          termName: t.name?.trim() || `Term ${index + 1}`,
          baseAmount: base,
          gstPercentage: isINR ? FIXED_GST_PERCENT : 0,
          gstAmount: gst,
          TDSAmmount: Number(t.tds) || 0,
          termTotal: total,
          status: t.status || "Pending",
          exchangeRate,
          totalInINR: !isINR ? total * exchangeRate : total,
        };
      }),
    };

    // keep old attachments
    payload.existingAttachments = uploadedFiles
      .filter((f) => f.isExisting)
      .map((f) => f.url);

    const formData = new FormData();
    formData.append("data", JSON.stringify(payload));

    uploadedFiles.forEach((fileObj) => {
      if (!fileObj.isExisting && fileObj.file) {
        formData.append("attachments", fileObj.file);
      }
    });
    console.log("========= DEBUG BEFORE API =========");

    // payload check
    console.log("PAYLOAD OBJECT →", payload);

    // check uploaded files array
    console.log("UPLOADED FILES →", uploadedFiles);

    // check FormData contents
    console.log("FORM DATA ENTRIES ↓");

    for (let [key, value] of formData.entries()) {
      if (key === "attachments") {
        console.log("FILE →", {
          field: key,
          name: value?.name,
          size: value?.size,
          type: value?.type,
        });
      } else if (key === "data") {
        try {
          console.log("DATA JSON →", JSON.parse(value));
        } catch {
          console.log("DATA RAW →", value);
        }
      } else {
        console.log(key, value);
      }
    }

    console.log("========= END DEBUG =========");
    // return

    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const response = await Instance.put(`/invoices/${id}`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200 || response.status === 201) {
        message.success("Invoice updated successfully!");
        console.log(response, "response");
        const companyId = invoiceData?.companyId?._id || invoiceData?.companyId;
        const getResponse = await Instance.get(
          `/invoices/Mark-False/standard/${selectedStandard}/companyId/${companyId}`,
        );

        console.log("📌 SECOND API RESPONSE →", getResponse.data);
        setTimeout(() => navigate("/tax-invoice"), 1000);
        // console.log(" edit response", response);
      }
    } catch (error) {
      console.error(error);
      message.error(
        error.response?.data?.message || "Failed to update invoice",
      );
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await Instance.get("/companyDetails");
      console.log("API Response:", response); // Check this in console!

      if (response.status === 200 || response.status === 201) {
        // Smart detection of array
        const companiesData = response?.data?.data || [];

        setCompanies(response?.data?.data);
        if (companiesData.length > 0) {
          setSelectedCompany(companiesData[0]);
        }
      }
    } catch (error) {
      console.error("Fetch error:", error);
      message.error("Failed to load company details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const [terms, setTerms] = useState([
    {
      name: "Term 1",
      amount: "",
      gstPercent: FIXED_GST_PERCENT,
      gstAmount: 0,
      tds: "",
      exchangeRate: "",
      total: 0,
      status: "Pending",
    },
  ]);
  const beforeUpload = (file) => {
    const isImage = file.type.startsWith("image/");
    if (!isImage) {
      message.error("You can only upload image files!");
      return Upload.LIST_IGNORE;
    }
    return true;
  };

  const handleLogoChange = (info) => {
    const file = info?.file?.originFileObj;
    if (file) {
      const isImage = file.type.startsWith("image/");
      if (!isImage) {
        message.error("You can only upload image files for logo!");
        return;
      }
      setLogoFile(file);
      setImageUrl(URL.createObjectURL(file));
    }
  };

  const uploadButton = (
    <div>
      <MdOutlineFileUpload size={28} />
      <div style={{ marginTop: 8 }}>Upload Logo</div>
    </div>
  );
  const [paymentTermsCount, setPaymentTermsCount] = useState(1);
  const [loading, setLoading] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState(false);

  const isINR = currency === "INR";
  useEffect(() => {
    if (!isINR && usdExchangeRate && totalClosure) {
      const totalInINR = parseFloat(totalClosure) * parseFloat(usdExchangeRate);
      setTotalBaseValueInr(totalInINR.toFixed(2));
    } else {
      setTotalBaseValueInr("");
    }
  }, [isINR, usdExchangeRate, totalClosure]);

  // Helper to compute GST and total (only for INR)
  const computeGstAndTotal = (base, gstPercent, tds) => {
    if (!isINR) {
      return {
        gstAmount: 0,
        total: parseFloat(String(base || 0)) || 0,
      };
    }

    const b = parseFloat(String(base || 0)) || 0;
    const g = (b * Number(gstPercent || FIXED_GST_PERCENT)) / 100;
    const tdsVal = parseFloat(String(tds || 0)) || 0;

    // Term Total = Base + GST only (TDS does NOT reduce it)
    const total = b + g;

    return {
      gstAmount: Number(g.toFixed(2)),
      total: Number(total.toFixed(2)),
      tdsAmount: Number(tdsVal.toFixed(2)), // optional: keep for reference
    };
  };

  // When currency changes, clear GST/TDS or Exchange Rate fields
  useEffect(() => {
    if (!isINR) {
      setGstNumber(""); // Clear GST number for non-INR

      setTerms((prev) =>
        prev.map((term) => ({
          ...term,
          gstPercent: 0,
          gstAmount: 0,
          tds: "",
          total: parseFloat(String(term.amount || 0)) || 0,
        })),
      );
    } else {
      // Recalculate GST for all terms when switching back to INR
      setTerms((prev) =>
        prev.map((term) => {
          const { gstAmount, total } = computeGstAndTotal(
            term.amount,
            FIXED_GST_PERCENT,
            term.tds,
          );
          return {
            ...term,
            gstPercent: FIXED_GST_PERCENT,
            gstAmount,
            exchangeRate: "",
            total,
          };
        }),
      );
    }
  }, [currency]);

  // Update term field and recalc derived values
  const updateTermField = (index, field, value) => {
    setTerms((prev) => {
      const copy = [...prev];
      const term = { ...copy[index] };

      if (field === "amount") {
        term.amount = value;
        if (isINR) {
          const { gstAmount, total } = computeGstAndTotal(
            value,
            term.gstPercent,
            term.tds,
          );
          term.gstAmount = gstAmount;
          term.total = total; // Base + GST only
        } else {
          term.total = parseFloat(String(value || 0)) || 0;
        }
      } else if (field === "tds") {
        term.tds = value;
        if (isINR) {
          const { gstAmount, total } = computeGstAndTotal(
            term.amount,
            term.gstPercent,
            value,
          );
          term.gstAmount = gstAmount;
          term.total = total; // Still Base + GST (TDS ignored in total)
        }
      } else if (field === "exchangeRate") {
        term.exchangeRate = value;
      } else if (field === "name") {
        term.name = value;
      } else if (field === "status") {
        term.status = value;
      }

      copy[index] = term;
      return copy;
    });
  };

  const addTermRow = () => {
    setTerms((prev) => [
      ...prev,
      {
        name: `Term ${prev.length + 1}`,
        amount: "",
        gstPercent: isINR ? FIXED_GST_PERCENT : 0,
        gstAmount: 0,
        tds: "",
        exchangeRate: "",
        total: 0,
        status: "Pending",
      },
    ]);
    setPaymentTermsCount((p) => p + 1);
  };

  const removeTermRow = (index) => {
    setTerms((prev) => prev.filter((_, i) => i !== index));
    setPaymentTermsCount((p) => Math.max(1, p - 1));
  };

  // Derived totals
  const totalBaseFromTerms = terms.reduce(
    (acc, t) => acc + (parseFloat(String(t.amount || 0)) || 0),
    0,
  );

  const totalGstFromTerms = isINR
    ? terms.reduce(
      (acc, t) => acc + (parseFloat(String(t.gstAmount || 0)) || 0),
      0,
    )
    : 0;

  const totalTdsFromTerms = isINR
    ? terms.reduce((acc, t) => acc + (parseFloat(String(t.tds || 0)) || 0), 0)
    : 0;

  const grandTotalFromTerms = totalBaseFromTerms + totalGstFromTerms;

  useEffect(() => {
    const closureValue = parseFloat(totalClosure) || 0;

    if (closureValue === 0) {
      setPendingAmount(0);
      return;
    }

    // Sum of base amounts from current invoice terms that are PAID
    const currentInvoicePaidBaseTotal = terms
      .filter((t) => t.status === "Paid")
      .reduce((sum, t) => sum + (parseFloat(t.amount) || 0), 0);

    // Sum of base amounts from all related invoices (all their terms)
    const relatedInvoicesBaseTotal = relatedInvoices.reduce(
      (sum, relInvoice) => {
        const relatedTermsSum = (relInvoice.terms || []).reduce(
          (termSum, term) => termSum + (parseFloat(term.baseAmount) || 0),
          0,
        );
        return sum + relatedTermsSum;
      },
      0,
    );
    const pending =
      closureValue - (currentInvoicePaidBaseTotal + relatedInvoicesBaseTotal);

    setPendingAmount(Math.max(0, pending));
  }, [totalClosure, terms, relatedInvoices]);

  // Match check
  const parsedTotalBase = parseFloat(String(totalClosure || 0)) || 0;
  const paymentTermsMatch =
    parsedTotalBase === 0
      ? true
      : Math.abs(totalBaseFromTerms - parsedTotalBase) < 0.01;

  const AgentOptions = agentData.map((agent) => ({
    label: agent.agentName,
    value: agent._id,
  }));
  const StandardsOptions = standards.map((s) => ({
    label: s.standardName,
    value: s._id,
  }));
  const handleDrop = (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files || []);
    addFiles(files);
  };

  const handleDragOver = (e) => e.preventDefault();

  const removeUploadedFile = (index) => {
    setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleViewFile = (fileObj) => {
    const url = URL.createObjectURL(fileObj.file);
    window.open(url, "_blank");
    setTimeout(() => URL.revokeObjectURL(url), 5000);
  };

  const handleDownloadFile = (fileObj) => {
    const url = URL.createObjectURL(fileObj.file);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileObj.name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    message.success("Certification Downloaded Successfully");
  };
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files || []);
    addFiles(files);
  };

  const addFiles = (files) => {
    const newFiles = files.map((file) => ({
      name: file.name,
      size: (file.size / 1024).toFixed(1) + " Kb",
      date: new Date().toLocaleDateString(),
      file,
    }));
    setUploadedFiles((prev) => [...prev, ...newFiles]);
  };

  return (
    <div>
      {showSuccessMsg && (
        <div className="success-alert d-flex justify-content-between align-items-center">
          <span>Tax invoice created successfully!</span>
          <span className="close-icon" onClick={() => setShowSuccessMsg(false)}>
            ×
          </span>
        </div>
      )}

      <div className="company-form mt-4 p-4">
        <div className="details-page">
          <ImgCrop rotationSlider aspect={1} shape="round" quality={1}>
            <Upload
              name="logo"
              listType="picture-circle"
              className="avatar-uploader"
              showUploadList={false}
              beforeUpload={beforeUpload}
              customRequest={({ onSuccess }) =>
                setTimeout(() => onSuccess("ok"), 0)
              }
              onChange={handleLogoChange}
            >
              {imageUrl ? (
                <img
                  src={imageUrl}
                  alt="Company Logo"
                  className="profile-img-preview"
                  draggable={false}
                />
              ) : (
                uploadButton
              )}
            </Upload>
          </ImgCrop>
        </div>
      </div>

      <div className="company-form mt-4">
        <div className="row ">
          {/* Tax Invoice No */}
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              Tax Invoice No <span style={{ color: "red" }}>*</span>
            </label>
            <input
              className="input-placeholder form-control"
              type="text"
              placeholder="enter tax invoice number"
              value={taxInvoiceNo}
              //   onChange={(e) => setTaxInvoiceNo(e.target.value)}
              readOnly
            />
            {taxInvoiceError && (
              <span className="text-danger small">{taxInvoiceError}</span>
            )}
            {errors.invoiceNo && (
              <span className="text-danger small">{errors.invoiceNo}</span>
            )}
          </div>

          {/* Currency */}
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              Currency <span style={{ color: "red" }}>*</span>
            </label>
            <Select
              showSearch
              className="custom-multi-select"
              style={{ width: "100%" }}
              placeholder="Select Currency"
              value={currency}
              options={[
                { label: "INR", value: "INR" },
                { label: "USD", value: "USD" },
                { label: "EUR", value: "EUR" },
                { label: "GBP", value: "GBP" },
                { label: "AUD", value: "AUD" },
                { label: "SAD", value: "SAD" },
                { label: "AE", value: "AE" },
                { label: "KW", value: "KW" },
              ]}
              onChange={(val) => setCurrency(val)}
              optionFilterProp="label"
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
            />
            {errors.currency && (
              <span className="text-danger small">{errors.currency}</span>
            )}
          </div>

          {/* Agent */}
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              Agent <span style={{ color: "red" }}>*</span>
            </label>
            <Select
              showSearch
              className="custom-multi-select"
              style={{ width: "100%" }}
              placeholder="Select Agent"
              options={AgentOptions}
              value={selectedAgent}
              onChange={(value) => setSelectedAgent(value)}
              optionFilterProp="label"
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
            />
            {errors.agent && (
              <span className="text-danger small">{errors.agent}</span>
            )}
          </div>

          {/* Standard */}
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              Standard <span style={{ color: "red" }}>*</span>
            </label>
            <Select
              mode="multiple"
              className="custom-multi-select"
              options={StandardsOptions}
              style={{ width: "100%" }}
              placeholder="select Standard"
              value={selectedStandard}
              onChange={(value) => setSelectedStandard(value)}
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
            />
            {errors.standard && (
              <span className="text-danger small">{errors.standard}</span>
            )}
          </div>

          {/* Company Name */}
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              Select Company <span style={{ color: "red" }}>*</span>
            </label>
            <Select
              showSearch
              allowClear
              labelInValue
              value={
                companyName
                  ? { value: companyId || companyName, label: companyName }
                  : undefined
              }
              placeholder="Type or select company name"
              className="custom-multi-select"
              style={{ width: "100%" }}
              options={companyDetails.map((c) => ({
                label: c.companyName,
                value: c._id,
              }))}
              onChange={(obj) => {
                if (!obj) return;

                // EXISTING COMPANY
                if (companyDetails.some((c) => c._id === obj.value)) {
                  setCompanyId(obj.value);
                  setCompanyName(obj.label);
                  handleCompanySelect(obj.value);
                }

                // NEW COMPANY SELECTED FROM TYPING
                else {
                  setCompanyId(null);
                  setCompanyName(obj.label);
                }
              }}
              onSearch={setSearchText}
              onInputKeyDown={(e) => {
                if (e.key === "Enter" && searchText?.trim()) {
                  e.preventDefault();

                  // NEW COMPANY TYPED
                  setCompanyName(searchText.trim());
                  setCompanyId(null); // ✅ IMPORTANT: no id for new company
                }
              }}
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            />
            {errors.companyName && (
              <span className="text-danger small">{errors.companyName}</span>
            )}
          </div>

          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Client Name</label>
            <input
              className="input-placeholder form-control"
              type="text"
              placeholder="Enter Client Name"
              value={clientName}
              onChange={(e) => setClientName(e.target.value)}
            />
          </div>

          {/* Phone */}
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Phone</label>
            <PhoneInput
              defaultCountry="in"
              value={phone}
              onChange={(value) => setPhone(value)}
              placeholder="Enter phone number"
              style={{ width: "100%" }}
            />
          </div>

          {/* Email */}
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Email</label>
            <input
              className="input-placeholder form-control"
              type="text"
              placeholder="Enter Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          {/* Address */}
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Address</label>
            <input
              className="input-placeholder form-control"
              type="text"
              placeholder="Enter Address"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
          </div>

          {/* Country */}
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Country</label>
            <Select
              showSearch
              className="custom-multi-select"
              style={{ width: "100%" }}
              placeholder="Select Country"
              options={countryOptions.map((c) => ({
                label: c.label,
                value: c.value,
              }))}
              value={selectedCountry?.value}
              onChange={(value) => {
                const selected = countryOptions.find((c) => c.value === value);
                setSelectedCountry(
                  selected
                    ? { label: selected.label, value: selected.value }
                    : null,
                );
              }}
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
            />
          </div>

          {/* City */}
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">City</label>
            <input
              className="input-placeholder form-control"
              type="text"
              placeholder="Enter city"
              value={city}
              onChange={(e) => setCity(e.target.value)}
            />
          </div>

          {/* Alternate Emails */}
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Alternate Emails</label>
            <div
              className="form-control d-flex flex-wrap align-items-center"
              style={{ minHeight: "38px" }}
            >
              {alternateEmails.map((a, idx) => (
                <span
                  key={idx}
                  className="badge bg-primary me-2 mb-1 d-flex align-items-center"
                  style={{ fontSize: "0.85rem" }}
                >
                  {a}
                  <button
                    type="button"
                    onClick={() =>
                      setAlternateEmails(
                        alternateEmails.filter((_, i) => i !== idx),
                      )
                    }
                    className="btn-close btn-close-white ms-2"
                    style={{ fontSize: "0.6rem" }}
                  />
                </span>
              ))}

              <input
                type="text"
                value={alternateEmailInput}
                onChange={(e) => setAlternateEmailInput(e.target.value)}
                onKeyDown={(e) => {
                  if (["Enter", ","].includes(e.key)) {
                    e.preventDefault();
                    const val = alternateEmailInput.trim();
                    if (val && !alternateEmails.includes(val)) {
                      setAlternateEmails([...alternateEmails, val]);
                      setAlternateEmailInput("");
                    }
                  }
                }}
                placeholder="Add alternate email and press Enter"
                style={{
                  border: "none",
                  outline: "none",
                  flex: 1,
                  minWidth: "150px",
                }}
              />
            </div>
          </div>

          {/* Website */}
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Website</label>
            <input
              className="input-placeholder form-control"
              type="text"
              placeholder="Enter Website"
              value={website}
              onChange={(e) => setWebsite(e.target.value)}
            />
          </div>

          {/* GST Number - Only for INR */}
          {isINR && (
            <div className="col-lg-4 mt-2">
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "500",
                }}
              >
                GST Number
              </label>
              <input
                className="input-placeholder form-control"
                type="text"
                placeholder="Enter GST Number"
                value={gstNumber}
                onChange={(e) => setGstNumber(e.target.value)}
              />
            </div>
          )}


          {isINR && (
            <div className="col-lg-4 mt-2">
              <label className="input-label form-label">
                Split Tax
              </label>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  height: "38px",
                }}
              >
                <input
                  type="checkbox"
                  checked={isSplitTax}
                  onChange={(e) => setIsSplitTax(e.target.checked)}
                  style={{
                    width: "18px",
                    height: "18px",
                    cursor: "pointer",
                  }}
                />

                <span>
                  {isSplitTax ? "CGST + SGST" : "IGST"}
                </span>
              </div>
            </div>
          )}


          {/* Total Closure */}
          <div className="col-lg-4 mt-2">
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "500",
              }}
            >
              Total Closure ({isINR ? "base amount" : "total amount"}){" "}
              <span style={{ color: "red" }}>*</span>
            </label>
            <input
              className="input-placeholder form-control"
              type="number"
              min={0}
              placeholder={isINR ? "Enter base amount" : "Enter total amount"}
              value={totalClosure}
              onChange={(e) => setTotalClosure(e.target.value)}
            />
            <small style={{ color: "#8c8c8c" }}>
              {isINR
                ? "Base amount (GST will be added per term)"
                : "Total amount (no GST applicable)"}
            </small>
            {errors.baseClosureAmount && (
              <span className="text-danger small">
                {errors.baseClosureAmount}
              </span>
            )}
          </div>
          {!isINR && (
            <div className="col-lg-4 mt-2">
              <label
                className="input-label form-label"
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "500",
                }}
              >
                Exchange Rate <span style={{ color: "red" }}>*</span>
              </label>
              <input
                className="input-placeholder form-control"
                type="number"
                placeholder="Enter exchange rate"
                value={usdExchangeRate}
                onChange={(e) => setUsdExchangeRate(e.target.value)}
              />
              {errors.exchangeRateForBaseClosure && (
                <span className="text-danger small">
                  {errors.exchangeRateForBaseClosure}
                </span>
              )}
            </div>
          )}

          {!isINR && (
            <div className="col-lg-4 mt-2">
              <label
                className="input-label form-label"
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "500",
                }}
              >
                Total Base Value In INR
              </label>
              <input
                className="input-placeholder form-control"
                type="text"
                value={totalBaseValueInr}
                readOnly
                style={{ backgroundColor: "#f8f9fa", color: "#495057" }}
              />
            </div>
          )}
          {/* Money Received */}
          <div className="col-lg-4 mt-2">
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "500",
              }}
            >
              Money Received (bank)
            </label>
            <input
              className="input-placeholder form-control"
              type="number"
              min={0}
              placeholder="Enter amount received"
              value={moneyReceived}
              onChange={(e) => setMoneyReceived(e.target.value)}
            />
          </div>

          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Certification Type</label>
            <input
              className="input-placeholder form-control"
              type="text"
              placeholder="Enter certification type"
              value={certificationType}
              onChange={(e) => setCertificationType(e.target.value)}
            />
          </div>

          {/* Payment Terms count */}
          <div className="col-lg-4 mt-2">
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "500",
              }}
            >
              Payment Terms (installments)
            </label>
            <Select
              options={[1, 2, 3, 4, 5, 6].map((n) => ({
                label: `${n}`,
                value: n,
              }))}
              className="custom-multi-select"
              style={{ width: "100%" }}
              value={paymentTermsCount}
              onChange={(val) => setPaymentTermsCount(val)}
            />
          </div>

          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">SAC Code</label>
            <input
              className="input-placeholder form-control"
              type="text"
              placeholder="Enter SAC Code"
              value={sacCode}
              onChange={(e) => setSacCode(e.target.value)}
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Invoice Date</label>
            <input
              className="input-placeholder form-control"
              type="date"
              placeholder="Enter invoice date"
              value={invoiceDate}
              onChange={(e) => setInvoiceDate(e.target.value)}
            />
          </div>
        </div>

        {/* Terms Table */}
        <div style={{ marginTop: "30px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "15px",
            }}
          >
            <h6 style={{ margin: 0, fontSize: "16px", fontWeight: "600" }}>
              Payment Terms
            </h6>
            <button
              type="button"
              onClick={addTermRow}
              style={{
                padding: "6px 16px",
                backgroundColor: "#1890ff",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              + Add Term
            </button>
          </div>

          <div style={{ overflowX: "auto" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                border: "1px solid #f0f0f0",
              }}
            >
              <thead>
                <tr style={{ backgroundColor: "#fafafa" }}>
                  <th
                    style={{
                      padding: "12px",
                      border: "1px solid #f0f0f0",
                      textAlign: "left",
                      minWidth: "50px",
                    }}
                  >
                    #
                  </th>
                  <th
                    style={{
                      padding: "12px",
                      border: "1px solid #f0f0f0",
                      textAlign: "left",
                      minWidth: "160px",
                    }}
                  >
                    Term Name
                  </th>
                  <th
                    style={{
                      padding: "12px",
                      border: "1px solid #f0f0f0",
                      textAlign: "left",
                      minWidth: "140px",
                    }}
                  >
                    {isINR ? "Base Amount" : "Amount"}
                  </th>
                  {isINR ? (
                    <>
                      <th
                        style={{
                          padding: "12px",
                          border: "1px solid #f0f0f0",
                          textAlign: "left",
                          minWidth: "90px",
                        }}
                      >
                        GST %
                      </th>
                      <th
                        style={{
                          padding: "12px",
                          border: "1px solid #f0f0f0",
                          textAlign: "left",
                          minWidth: "120px",
                        }}
                      >
                        GST Amount
                      </th>
                      <th
                        style={{
                          padding: "12px",
                          border: "1px solid #f0f0f0",
                          textAlign: "left",
                          minWidth: "100px",
                        }}
                      >
                        TDS
                      </th>
                    </>
                  ) : (
                    <th
                      style={{
                        padding: "12px",
                        border: "1px solid #f0f0f0",
                        textAlign: "left",
                        minWidth: "140px",
                      }}
                    >
                      Exchange Rate ({currency} to INR)
                    </th>
                  )}
                  <th
                    style={{
                      padding: "12px",
                      border: "1px solid #f0f0f0",
                      textAlign: "left",
                      minWidth: "140px",
                    }}
                  >
                    Term Total
                  </th>
                  {!isINR && (
                    <th
                      style={{
                        padding: "12px",
                        border: "1px solid #f0f0f0",
                        textAlign: "left",
                        minWidth: "140px",
                      }}
                    >
                      Total in INR
                    </th>
                  )}
                  <th
                    style={{
                      padding: "12px",
                      border: "1px solid #f0f0f0",
                      textAlign: "left",
                      minWidth: "140px",
                    }}
                  >
                    Status
                  </th>
                  <th
                    style={{
                      padding: "12px",
                      border: "1px solid #f0f0f0",
                      textAlign: "center",
                      width: "70px",
                    }}
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {terms.map((term, idx) => {
                  const termInINR = !isINR
                    ? (parseFloat(String(term.total || 0)) || 0) *
                    (parseFloat(String(term.exchangeRate || 0)) || 0)
                    : 0;

                  return (
                    <tr key={idx}>
                      <td
                        style={{ padding: "8px", border: "1px solid #f0f0f0" }}
                      >
                        {idx + 1}
                      </td>
                      <td
                        style={{ padding: "8px", border: "1px solid #f0f0f0" }}
                      >
                        <input
                          style={{
                            width: "100%",
                            padding: "6px",
                            border: "1px solid #d9d9d9",
                            borderRadius: "4px",
                          }}
                          type="text"
                          value={term.name}
                          onChange={(e) =>
                            updateTermField(idx, "name", e.target.value)
                          }
                          placeholder={`Term ${idx + 1} name`}
                        />
                      </td>
                      <td
                        style={{ padding: "8px", border: "1px solid #f0f0f0" }}
                      >
                        <input
                          style={{
                            width: "100%",
                            padding: "6px",
                            border: "1px solid #d9d9d9",
                            borderRadius: "4px",
                          }}
                          type="number"
                          min={0}
                          value={term.amount}
                          onChange={(e) =>
                            updateTermField(idx, "amount", e.target.value)
                          }
                          placeholder="0.00"
                        />
                      </td>
                      {isINR ? (
                        <>
                          <td
                            style={{
                              padding: "8px",
                              border: "1px solid #f0f0f0",
                            }}
                          >
                            <input
                              style={{
                                width: "100%",
                                padding: "6px",
                                backgroundColor: "#f5f5f5",
                                border: "1px solid #d9d9d9",
                                borderRadius: "4px",
                              }}
                              type="number"
                              readOnly
                              value={FIXED_GST_PERCENT}
                              disabled
                            />
                          </td>
                          <td
                            style={{
                              padding: "8px",
                              border: "1px solid #f0f0f0",
                            }}
                          >
                            <input
                              style={{
                                width: "100%",
                                padding: "6px",
                                backgroundColor: "#f5f5f5",
                                border: "1px solid #d9d9d9",
                                borderRadius: "4px",
                              }}
                              type="text"
                              readOnly
                              value={Number(term.gstAmount || 0).toFixed(2)}
                            />
                          </td>
                          <td
                            style={{
                              padding: "8px",
                              border: "1px solid #f0f0f0",
                            }}
                          >
                            <input
                              style={{
                                width: "100%",
                                padding: "6px",
                                border: "1px solid #d9d9d9",
                                borderRadius: "4px",
                              }}
                              type="number"
                              min={0}
                              value={term.tds}
                              onChange={(e) =>
                                updateTermField(idx, "tds", e.target.value)
                              }
                              placeholder="0.00"
                            />
                          </td>
                        </>
                      ) : (
                        <td
                          style={{
                            padding: "8px",
                            border: "1px solid #f0f0f0",
                          }}
                        >
                          <input
                            style={{
                              width: "100%",
                              padding: "6px",
                              border: "1px solid #d9d9d9",
                              borderRadius: "4px",
                            }}
                            type="number"
                            min={0}
                            step="0.01"
                            value={term.exchangeRate}
                            onChange={(e) =>
                              updateTermField(
                                idx,
                                "exchangeRate",
                                e.target.value,
                              )
                            }
                            placeholder="e.g., 83.50"
                          />
                          {errors?.terms?.[idx]?.exchangeRate && (
                            <div className="text-danger small">
                              {errors.terms[idx].exchangeRate}
                            </div>
                          )}
                        </td>
                      )}
                      <td
                        style={{ padding: "8px", border: "1px solid #f0f0f0" }}
                      >
                        <input
                          style={{
                            width: "100%",
                            padding: "6px",
                            backgroundColor: "#f5f5f5",
                            border: "1px solid #d9d9d9",
                            borderRadius: "4px",
                          }}
                          type="text"
                          readOnly
                          value={`${currency} ${Number(term.total || 0).toFixed(
                            2,
                          )}`}
                        />
                      </td>
                      {!isINR && (
                        <td
                          style={{
                            padding: "8px",
                            border: "1px solid #f0f0f0",
                          }}
                        >
                          <input
                            style={{
                              width: "100%",
                              padding: "6px",
                              backgroundColor: "#f5f5f5",
                              border: "1px solid #d9d9d9",
                              borderRadius: "4px",
                            }}
                            type="text"
                            readOnly
                            value={`INR ${termInINR.toFixed(2)}`}
                          />
                          {errors?.terms?.[idx]?.totalInINR && (
                            <div className="text-danger small">
                              {errors.terms[idx].totalInINR}
                            </div>
                          )}
                        </td>
                      )}
                      <td
                        style={{ padding: "8px", border: "1px solid #f0f0f0" }}
                      >
                        <Select
                          style={{ width: "100%" }}
                          value={term.status}
                          options={[
                            { label: "Pending", value: "Pending" },
                            { label: "Paid", value: "Paid" },
                          ]}
                          onChange={(val) =>
                            updateTermField(idx, "status", val)
                          }
                        />
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #f0f0f0",
                          textAlign: "center",
                        }}
                      >
                        <button
                          type="button"
                          onClick={() => removeTermRow(idx)}
                          disabled={terms.length === 1}
                          style={{
                            padding: "6px 10px",
                            backgroundColor:
                              terms.length === 1 ? "#d9d9d9" : "#ff4d4f",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            cursor:
                              terms.length === 1 ? "not-allowed" : "pointer",
                          }}
                          title="Remove term"
                        >
                          <AiOutlineDelete />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {/* Validation */}
          {!paymentTermsMatch && (
            <div style={{ marginTop: "10px" }}>
              <span style={{ color: "#ff4d4f", fontSize: "14px" }}>
                Sum of term {isINR ? "base" : ""} amounts (
                {totalBaseFromTerms.toFixed(2)}) must equal Total Closure (
                {parsedTotalBase.toFixed(2)})
              </span>
            </div>
          )}

          {/* Totals Summary */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "30px",
              marginTop: "20px",
              flexWrap: "wrap",
            }}
          >
            <div>
              <div
                style={{
                  fontSize: "12px",
                  color: "#8c8c8c",
                  marginBottom: "4px",
                }}
              >
                {isINR ? "Total Base Amount" : "Total Amount"}
              </div>
              <div style={{ fontWeight: "600", fontSize: "16px" }}>
                {currency} {totalBaseFromTerms.toFixed(2)}
              </div>
            </div>

            {isINR && (
              <>
                <div>
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#8c8c8c",
                      marginBottom: "4px",
                    }}
                  >
                    Total GST
                  </div>
                  <div style={{ fontWeight: "600", fontSize: "16px" }}>
                    INR {totalGstFromTerms.toFixed(2)}
                  </div>
                </div>
                <div>
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#8c8c8c",
                      marginBottom: "4px",
                    }}
                  >
                    Total TDS
                  </div>
                  <div style={{ fontWeight: "600", fontSize: "16px" }}>
                    INR {totalTdsFromTerms.toFixed(2)}
                  </div>
                </div>
              </>
            )}

            <div>
              <div
                style={{
                  fontSize: "12px",
                  color: "#8c8c8c",
                  marginBottom: "4px",
                }}
              >
                Grand Total {isINR ? "(Base + GST - TDS)" : ""}
              </div>
              <div style={{ fontWeight: "600", fontSize: "16px" }}>
                {currency} {grandTotalFromTerms.toFixed(2)}
              </div>
            </div>

            <div>
              <div
                style={{
                  fontSize: "12px",
                  color: "#8c8c8c",
                  marginBottom: "4px",
                }}
              >
                Pending Payment
              </div>
              <div
                style={{
                  fontWeight: "600",
                  fontSize: "16px",
                  color: "#ff4d4f",
                }}
              >
                {currency} {pendingAmount.toFixed(2)}
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-4 mt-2">
          <label>Select Company</label>
          <select
            className="form-select"
            value={selectedCompany?._id || ""}
            onChange={(e) => {
              const company =
                companies.find((c) => c._id === e.target.value) || null;

              setSelectedCompany(company);

              // optional: reset bank if you still use it
              setSelectedBank(null);
            }}
          >
            <option value=""> Select Company </option>
            {companies?.map((company) => (
              <option key={company._id} value={company._id}>
                {company?.companyName}
              </option>
            ))}
          </select>
        </div>
        {selectedCompany && (
          <div className="col-lg-4 mt-2">
            {" "}
            <label>Select Bank</label>{" "}
            <select
              className="form-select"
              value={selectedBank?.accountNumber || ""}
              onChange={(e) => {
                const bank = selectedCompany.bankDetails.find(
                  (b) => b.accountNumber === e.target.value,
                );
                setSelectedBank(bank);
              }}
            >
              {" "}
              <option value=""> Select Bank </option>{" "}
              {selectedCompany.bankDetails.map((bank, index) => (
                <option key={index} value={bank.accountNumber}>
                  {" "}
                  {bank.country}-{bank.bankName}
                </option>
              ))}{" "}
            </select>{" "}
          </div>
        )}

        {selectedBank && (
          <div className="card p-3 mt-3">
            <h5>Bank Details</h5>

            <p>
              <strong>Bank:</strong> {selectedBank?.bankName}
            </p>

            <p>
              <strong>Account Number:</strong> {selectedBank?.accountNumber}
            </p>

            <p>
              <strong>Country:</strong> {selectedBank?.country || "India"}
            </p>

            {selectedBank?.country === "India" ? (
              <>
                <p>
                  <strong>IFSC Code:</strong> {selectedBank?.ifscCode || "-"}
                </p>
                <p>
                  <strong>Beneficiary Name:</strong>{" "}
                  {selectedBank?.beneficiaryName || "-"}
                </p>
                <p>
                  <strong>SWIFT Code:</strong> {selectedBank?.swiftCode || "-"}
                </p>
                <p>
                  <strong>Bank Address:</strong>{" "}
                  {selectedBank?.branchAddress || "-"}
                </p>
              </>
            ) : (
              <>
                <p>
                  <strong>Account Holder:</strong>{" "}
                  {selectedBank?.accountHolderName || "-"}
                </p>
                <p>
                  <strong>Routing Code:</strong>{" "}
                  {selectedBank?.routingCode || "-"}
                </p>
                <p>
                  <strong>Routing Type:</strong>{" "}
                  {selectedBank?.routingType || "-"}
                </p>
                <p>
                  <strong>Payment Method:</strong>{" "}
                  {selectedBank?.paymentMethod || "-"}
                </p>
                <p>
                  <strong>Bank Address:</strong>{" "}
                  {selectedBank?.bankAddress || "-"}
                </p>
              </>
            )}
          </div>
        )}

        <div className="col-lg-12 mt-4">
          <label className="input-label form-label">Attachment</label>
          <div
            className="upload-box"
            onDrop={handleDrop}
            onDragOver={handleDragOver}
          >
            <input
              id="fileInput"
              type="file"
              multiple
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
            <p
              className="upload-text"
              onClick={() => document.getElementById("fileInput").click()}
            >
              Drag and Drop Attachment here or{" "}
              <span className="upload-link">click to Upload</span>{" "}
              <span className="upload-icon">
                <MdOutlineFileUpload />
              </span>
            </p>
          </div>
        </div>

        {/* File Details Table */}
        {uploadedFiles.length > 0 && (
          <div className="table-responsive">
            <table className="file-table">
              <thead>
                <tr>
                  <th>File Name</th>
                  <th>Size</th>
                  <th>Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {uploadedFiles.map((file, index) => (
                  <tr key={index}>
                    <td>{file.name}</td>
                    <td>{file.size}</td>
                    <td>{file.date}</td>
                    <td className="file-actions">
                      <AiOutlineEye
                        className="action-icon"
                        onClick={() => handleViewFile(file)}
                      />
                      <AiOutlineDownload
                        className="action-icon"
                        onClick={() => handleDownloadFile(file)}
                      />
                      <AiOutlineDelete
                        className="action-icon"
                        onClick={() => removeUploadedFile(index)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Buttons */}
        <div className="d-flex justify-content-end gap-3 mt-4 col-12">
          <button
            className="discard-btn"
            onClick={() => navigate("/tax-invoice")}
          >
            Discard
          </button>

          <button className="save-btn" onClick={handleSave} disabled={loading}>
            {loading ? (
              <Spin
                indicator={
                  <LoadingOutlined
                    style={{ fontSize: 24, color: "#fff" }}
                    spin
                  />
                }
              />
            ) : (
              "Save"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditTaxInvoice;
